export const MenuItemsJoinLink = [
  {
    title: 'Sponsor Us',
    path: '/sponsor',
    cName: 'dropdown-link'
  }, {
    title: 'Collaborate With Us',
    path: '/collab-with-us',
    cName: 'dropdown-link'
  },
];

export const MenuItemsJoin = [
  {
    title: 'Join Team',
    path: 'https://docs.google.com/forms/d/e/1FAIpQLSeMYmaEi2dB6kytPFANlg_oF0Aa7rXiBWcV4UJE1_IjoOCvHQ/viewform',
    cName: 'dropdown-link',
    target: '_blank',
    rel: 'noreferrer'
  },
  {
    title: 'Join Our Community',
    path: 'https://www.facebook.com/groups/upwardbangladesh/',
    cName: 'dropdown-link',
    target: '_blank',
    rel: 'noreferrer'
  }
]